import { ArrowUpRight } from "lucide-react";
import { MEDIA } from "@/data/media";
import { EVENTS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const EventsSection = ({ onInquire }) => {
  return (
    <section
      id="events"
      data-testid="events-partnerships-section"
      className="relative"
      style={{ backgroundColor: "var(--bg-2)" }}
    >
      <div className="grid lg:grid-cols-2">
        {/* Image side */}
        <div className="relative order-2 min-h-[340px] lg:order-1 lg:min-h-[700px]">
          <img
            src={MEDIA.eventsImage}
            alt="Wellness events and partnerships"
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(to right, rgba(11,10,8,0.25), rgba(11,10,8,0.85))",
            }}
          />
        </div>

        {/* Content side */}
        <div className="order-1 flex min-w-0 items-center px-6 py-16 sm:px-10 lg:order-2 lg:px-14 lg:py-24">
          <div className="w-full min-w-0">
            <Reveal>
              <p className="eyebrow">{EVENTS.eyebrow}</p>
              <h2
                className="display mt-5"
                style={{ fontSize: "clamp(2.4rem, 5vw, 4rem)", fontWeight: 500 }}
              >
                {EVENTS.headline_lead}{" "}
                <span className="accent-italic">{EVENTS.headline_accent}</span>
              </h2>
              <p
                className="mt-6 max-w-lg"
                style={{
                  color: "var(--text-2)",
                  fontSize: "1rem",
                  lineHeight: 1.7,
                }}
              >
                {EVENTS.body}
              </p>
            </Reveal>

            <div className="mt-9 grid grid-cols-1 sm:grid-cols-2">
              {EVENTS.categories.map((c, i) => (
                <Reveal key={c} delay={i * 0.05}>
                  <div
                    data-testid={`events-category-${i}`}
                    className="py-4"
                    style={{ borderTop: "1px solid var(--border-c)" }}
                  >
                    <span
                      style={{
                        fontFamily: "var(--font-sans)",
                        textTransform: "uppercase",
                        letterSpacing: "0.12em",
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        color: "var(--text)",
                      }}
                    >
                      {c}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.1}>
              <button
                type="button"
                data-testid="events-inquire-button"
                onClick={onInquire}
                className="events-inquire-cta btn-fx btn-primary mt-10"
              >
                <span>Inquire About Partnerships</span>
                <ArrowUpRight size={16} style={{ flexShrink: 0 }} />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
